import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#404040'
const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 2,
        borderWidth: 1,
        borderColor: '#404040',
    },
    row: {
        flexDirection: 'row',
        borderBottomColor: '#404040',
        borderBottomWidth: 1,
        alignItems: 'left',
        height: 24,
        fontSize: 10,
        fontStyle: 'bold',
    },
    bankTitle: {
        width: '40%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
        paddingTop: 5,
    },
    bankData: {
        width: '60%',
        paddingLeft: 8,
        paddingTop: 5,
    },
  });

const InvoiceBankDetailsTable = ({invoice}) => {
    // const total = items.map(item => item.qty * item.rate)
    //     .reduce((accumulator, currentValue) => accumulator + currentValue , 0)

    return(    
        <View style={styles.tableContainer}>
            <View style={styles.row}>
                <Text style={styles.bankTitle}>Account Name</Text>
                <Text style={styles.bankData}>{invoice.account_name}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.bankTitle}>Account Number</Text>
                <Text style={styles.bankData}>{invoice.account_no}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.bankTitle}>Bank</Text>
                <Text style={styles.bankData}>{invoice.bank}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.bankTitle}>Branch</Text>
                <Text style={styles.bankData}>{invoice.branch}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.bankTitle}>IFSC</Text>
                <Text style={styles.bankData}>{invoice.IFSC}</Text>
            </View>
        </View>
    )
};
  
  export default InvoiceBankDetailsTable